// @ts-nocheck
import { AssetInfoType } from "./types";
import {
  ETHLogo,
  BTCLogo,
  BNBLogo,
  USDTLogo,
  USDCLogo,
  EUROCLogo,
  TSLALogo,
  NVDALogo,
  AAPLLogo,
  XAULogo,
  XAGLogo,
  JPYLogo,
  SPXLogo,
  ANTHROPICLogo,
  MATICLogo,
  XRPLogo,
  SOLLogo,
  WLDLogo,
  CRVLogo,
  SEILogo,
  OXLogo,
  FRIENDLogo,
  ARBLogo,
  OPLogo,
  PEPELogo,
  NMRLogo,
  SYNLogo,
  BANANALogo,
  HIFILogo,
  MKRLogo,
  LINKLogo,
  GLMRLogo,
  BLZLogo,
  TIALogo,
  CANTOLogo,
  BITCOINLogo,
  AVAXLogo,
  DYDXLogo,
  TLogo,
} from "./logos";

// The key eg. "ETH" MUST match the correct asset symbol returned from api
export const assetsPart1: AssetInfoType = {
  ETH: {
    logo: ETHLogo,
    name: "Ethereum",
    description:
      "Ethereum is a decentralized, open-source blockchain with smart contract functionality. Ether is the native cryptocurrency of the platform.",
  },
  BTC: {
    logo: BTCLogo,
    name: "Bitcoin",
    description:
      "Bitcoin is a decentralized digital currency, without a central bank or single administrator, that can be sent from user to user on the peer-to-peer bitcoin network. Bitcoin is the first and most widely recognized cryptocurrency.",
  },
  BNB: {
    logo: BNBLogo,
    name: "Binance Coin",
    description:
      "Binance Coin is a cryptocurrency issued by Binance Exchange, and trades with the BNB symbol. BNB was initially created on the Ethereum blockchain but has since become the native currency of the Binance Chain. Binance Coin has several use cases including trading fee discounts on the Binance Exchange.",
  },
  USDT: {
    logo: USDTLogo,
    name: "Tether",
    description:
      "Tether USD is a cryptocurrency stablecoin pegged to the U.S. dollar and backed '100% by Tether's reserves,' according to its website. Tether is owned by iFinex, the Hong Kong-registered company that also owns the crypto exchange BitFinex.",
  },
  USDC: {
    logo: USDCLogo,
    name: "USD Coin",
    description:
      "USDC is a stablecoin that is pegged to the U.S. dollar on a 1:1 basis. Every unit of this cryptocurrency in circulation is backed up by $1 that is held in reserve, in a mix of cash and short-term U.S. Treasury bonds. The Centre consortium, which is behind this asset, says USDC is issued by regulated financial institutions.",
  },
  EUROC: {
    logo: EUROCLogo,
    name: "Euro Coin",
    description:
      "Euro Coin is a euro-denominated stablecoin issued by Circle.",
  },
  EURC: {
    logo: EUROCLogo,
    name: "Euro Coin",
    description:
      "Euro Coin is a euro-denominated stablecoin issued by Circle.",
  },
  TSLA: {
    logo: TSLALogo,
    name: "Tesla",
    description: "Tesla equity perpetual market.",
  },
  NVDA: {
    logo: NVDALogo,
    name: "NVIDIA",
    description: "NVIDIA equity perpetual market.",
  },
  AAPL: {
    logo: AAPLLogo,
    name: "Apple",
    description: "Apple equity perpetual market.",
  },
  XAU: {
    logo: XAULogo,
    name: "Gold",
    description: "Gold commodity perpetual market.",
  },
  XAG: {
    logo: XAGLogo,
    name: "Silver",
    description: "Silver commodity perpetual market.",
  },
  EUR: {
    logo: EUROCLogo,
    name: "Euro",
    description: "Euro FX perpetual market.",
  },
  JPY: {
    logo: JPYLogo,
    name: "Japanese Yen",
    description: "Japanese yen FX perpetual market.",
  },
  SPX: {
    logo: SPXLogo,
    name: "S&P 500",
    description: "S&P 500 index perpetual market.",
  },
  ANTHROPIC: {
    logo: ANTHROPICLogo,
    name: "Anthropic",
    description: "Anthropic pre-IPO perpetual market.",
  },
  MATIC: {
    logo: MATICLogo,
    name: "Polygon",
    description:
      "Polygon (Previously Matic Network) is the first well-structured, easy-to-use platform for Ethereum scaling and infrastructure development. Its core component is Polygon SDK, a modular, flexible framework that supports building multiple types of applications.",
  },
  XRP: {
    logo: XRPLogo,
    name: "Ripple",
    description:
      "Ripple is a privately-held fintech company that provides a global payment solution via its patented payment network called Ripple Network (also known as RippleNet). Unlike most cryptocurrencies out there that cater to peer-to-peer needs, Ripple was made to connect banks, payment providers and digital asset exchanges, enabling real-time settlement expeditions and lower transaction fees.",
  },
  SOL: {
    logo: SOLLogo,
    name: "Solana",
    description:
      "Solana is a Layer 1 blockchain that offers users fast speeds and affordable costs. It supports smart contracts and facilitates the creation of decentralized applications (dApps). Projects built on Solana include a variety of DeFi platforms as well as NFT marketplaces, where users can buy Solana-based NFT projects. Its high performance means Solana doesn’t require a traditional scaling Layer 2 solution; instead, Layer 2s on Solana focus on interoperability and connecting Solana to other chains.",
  },
  WLD: {
    logo: WLDLogo,
    name: "Worldcoin",
    description:
      "Worldcoin was founded with the mission of creating a globally-inclusive identity and financial network, owned by the majority of humanity. Worldcoin consists of a privacy-preserving digital identity network (World ID) built on proof of personhood and, where laws allow, a digital currency (WLD).",
  },
  CRV: {
    logo: CRVLogo,
    name: "Curve",
    description:
      "CRV is the governance token for Curve Finance. It implemented a complex time-based staking system to exchange CRV into veCRV, where veCRV is an internal token intended for governance purpose and has a right to claim the cash flows generated by the protocol.",
  },
  SEI: {
    logo: SEILogo,
    name: "SEI",
    description:
      "Sei is a general purpose, open-source Layer 1 blockchain specialized for for the exchange of digital assets. Leveraging a novel consensus and technical breakthroughs, Sei is the fastest blockchain in the industry.",
  },
  OX: {
    logo: OXLogo,
    name: "Open Exchange",
    description:
      "OX is the native fee paying, staking and governance token of OPNX.",
  },
  FRIEND: {
    logo: FRIENDLogo,
    name: "Friend",
    description:
      "FRIEND is a tradeable market for the market cap of accounts on friend.tech, a social tokenization protocol based on Coinbase’s Base L2. The platform empowers personalities, especially from platforms like X (formerly Twitter), to issue shares on its app, granting access to exclusive group chats.",
  },
  ARB: {
    logo: ARBLogo,
    name: "Arbitrum",
    description:
      "Arbitrum is a rollup chain, which is a layer 2 solution that aggregates and processes transactions off-chain, before submitting a single transaction to the Ethereum mainnet.",
  },
  OP: {
    logo: OPLogo,
    name: "Optimism",
    description:
      "Optimism is a rollup chain, which is a layer 2 solution that aggregates and processes transactions off-chain, before submitting a single transaction to the Ethereum mainnet.",
  },
  "1000PEPE": {
    logo: PEPELogo,
    name: "PEPE",
    description:
      "Pepe Coin, often referred to simply as Pepe by crypto and meme coin fans, was launched in late April 2023 as a tongue-in-cheek and humorous digital currency inspired by the popular internet meme Pepe the Frog.",
  },
  NMR: {
    logo: NMRLogo,
    name: "Numeraire",
    description:
      "Numeraire (NMR) is an ERC-20 token created by Numerai, a hedge fund company based in San Francisco. NMR is native to the Erasure Protocol, a decentralized prediction staking platform. On this prediction staking platform, NMR is rewarded in weekly tournament payouts for successful predictions while NMR staked is destroyed for unsuccessful predictions.",
  },
  SYN: {
    logo: SYNLogo,
    name: "Synapse",
    description:
      "Synapse (SYN) is an interoperability protocol designed for safely and securely sending arbitrary data between blockchains.",
  },
  BANANA: {
    logo: BANANALogo,
    name: "Banana Gun",
    description:
      "Banana Gun (BANANA) is a Telegram bot that allows you to snipe upcoming launches, or safely buy tokens that are already live.",
  },
  HIFI: {
    logo: HIFILogo,
    name: "Hifi",
    description:
      "Hifi Finance (HIFI) is a lending protocol that addresses the need for fixed-rate lending and borrowing in decentralized finance.",
  },
  MKR: {
    logo: MKRLogo,
    name: "Maker",
    description:
      "The Maker token (MKR) is a governance token that is used to govern and recapitalize the Maker protocol. Holders of the token can participate and vote on changes to the protocol’s smart contract and system parameters such as Stability Fees and the Dai Savings Rate (DSR).",
  },
  LINK: {
    logo: LINKLogo,
    name: "Link",
    description:
      "Chainlink is a decentralized oracle service. The LINK token is used to pay node operators for retrieving data for smart contracts and also for deposits placed by node operators as required by contract creators.",
  },
  GLMR: {
    logo: GLMRLogo,
    name: "Moonbeam",
    description:
      "Moonbeam is an Ethereum-compatible smart contract parachain on Polkadot. Moonbeam makes it easy to use popular Ethereum developer tools to build or redeploy Solidity projects in a Substrate-based environment.",
  },
  BLZ: {
    logo: BLZLogo,
    name: "Bluzelle",
    description:
      "Bluzelle is a decentralized storage network for the creator economy. Bluzelle delivers high security, un-matched availability, and is censorship resistant.",
  },
  TIA: {
    logo: TIALogo,
    name: "Celestia",
    description:
      "Celestia is a modular consensus and data network, built to enable anyone to easily deploy their own blockchain with minimal overhead.",
  },
  CANTO: {
    logo: CANTOLogo,
    name: "Canto",
    description:
      "Canto (CANTO) is a decentralized blockchain operating within the Cosmos ecosystem, emphasizing the accessibility and development of Decentralized Finance (DeFi). Launched in August 2022, it provides an open platform for DeFi initiatives, promoting transparency and decentralization.",
  },
  BITCOIN: {
    logo: BITCOINLogo,
    name: "HarryPotterObamaSonic10Inu (ETH)",
    description:
      "HarryPotterObamaSonic10Inu (Ticker: BITCOIN) is a crypto asset incentivizing unique meme content creation.",
  },
  AVAX: {
    logo: AVAXLogo,
    name: "AVAX",
    description:
      "Avalanche is a high throughput smart contract blockchain platform.",
  },
  DYDX: {
    logo: DYDXLogo,
    name: "DYDX",
    description:
      "dYdX is a governance token used to govern the dYdX Layer 2 exchange protocol to align incentives between traders, liquidity providers, and partners.",
  },
  T: {
    logo: TLogo,
    name: "T",
    description:
      "Threshold Network (T) is the on-chain merger between two existing networks (NU and KEEP). The platform is the only decentralized Bitcoin bridging protocol.",
  },
};
